export const INVOICINGS_PATH = "/admin/invoicings";
export const POSITIONS_PATH = "/admin/weployees";
export const REFERRALS_PATH = "/admin/referrals";
export const APPLICATIONS_PATH = "/admin/jobs/:jobId/job_applications";
export const JOBS_PAGE_PATH = "/admin/jobs";
export const INTERVIEW_PAGE_PATH = "/admin/interviews/:id";
export const ACTIVE_POSITIONS_PATH = "/admin/api/active_positions";
export const JOB_APPLICATIONS_PATH = "/admin/api/job_applications";
export const JOBS_PATH = "/admin/api/jobs";
export const GET_REFERRALS_PATH = "/admin/api/referral_candidates";
export const SEND_MESSAGE_PATH = "/admin/api/bulk_sms_messages";
export const ADMIN_COMMENT_PATH = "/admin/api/comments";
export const ADMIN_COMMUNITY_MEMBER_PATH = (id: string) =>
  `/admin/community_members/${id}`;
export const ADMIN_COMMUNITY_MEMBER_PROFILES_PATH = (positionId: string) =>
  `/admin/api/community_member_profiles/${positionId}`;
export const ADMIN_ONBOARDING_PATH = (positionId: string) =>
  `/admin/api/user_onboardings/${positionId}`;
export const ADMIN_COACHING_PATH = (positionId: string) =>
  `/admin/api/coachings/${positionId}`;
export const ADMIN_TAGGERS_PATH = `/admin/api/taggers`;
export const COMPANIES_PATH = "/admin/invoicings/client_companies";
export const ATTENDANCES_PATH =
  "/admin/invoicings/client_companies/:clientCompanyId/attendances";
export const ADMIN_ABSENCE_PATH = (positionId: string) =>
  `/admin/api/position_absents/${positionId}`;
export const ADMIN_PERFORMANCE_RECORDS_PATH = (positionId: string) =>
  `/admin/api/performance_records/${positionId}`;
export const ADMIN_PERFORMANCE_FIELDS_PATH = (positionId: string) =>
  `/admin/api/performance_fields/${positionId}`;
